import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction, current } from "@reduxjs/toolkit";
import { compareKeys } from "src/forms/tools";
// Define a type for the slice state
interface ReviewPageState {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Stores snapshot of entire forms state which has dynamic shape
  formsStateFirstLoad: any;
  formsStateSaved: boolean;
}
export const initialState: ReviewPageState = {
  formsStateFirstLoad: null,
  formsStateSaved: false,
};
export const verifyStateIsValid = (state: ReviewPageState) => {
  return compareKeys(state, initialState);
};
export const reviewPageSlice = createSlice({
  name: "reviewPage",
  initialState,
  reducers: {
    setFormsStateFirstLoad: (
      state: ReviewPageState,
      action: PayloadAction<{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Generic setter accepts any state value type
        value: any;
      }>
    ) => {
      const { value } = action.payload;
      if (!current(state).formsStateSaved) {
        state.formsStateFirstLoad = value;
        state.formsStateSaved = true;
      }
    },
    resetReviewPageState: () => {
      return initialState;
    },
  },
});

export const { setFormsStateFirstLoad, resetReviewPageState } = reviewPageSlice.actions;

export default reviewPageSlice.reducer;
